// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Rkwb","right":"Footer_right__2jlUq","buttons":"Footer_buttons__wYbeD"};